import { useCallback, useRef } from 'react';

export type FnType<T extends any[], U> = (...props: T) => U;

export function useEvent<T extends (...args: any[]) => any>(handler: T): T {
  const handlerRef = useRef<T>(handler);

  handlerRef.current = handler;

  // eslint-disable-next-line
  // @ts-ignore
  return useCallback<T>((...args) => handlerRef.current(...args), [handlerRef]);
}
